import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import Accordion from '../../../_shared/accordion';
import srcIcon from 'assets/images/User-Question.png';
import { useSurveyContent } from '../../../../shared/hooks';
import { surveyPortalMixpanel } from '../../../../vendor/mixpanel';

const Quota = () => {
  const SEID = window.location.pathname.split('/').pop();
  const { surveyContent } = useSurveyContent();
  const source = surveyContent?.survey_host ?? '';
  const survey_id = surveyContent?.survey_id ?? '';
  const environment = process.env.REACT_APP_ENV;
  let suffix = '';
  if (environment === 'local' || environment === 'development') {
    suffix = '.dev';
  } else if (environment === 'staging') {
    suffix = '.staging';
  }
  const hasTrackedRef = React.useRef(false);
  React.useEffect(() => {
    if (!hasTrackedRef.current && surveyContent?.subject) {
      surveyPortalMixpanel.track('Quota Page Viewed', {
        SSEID: surveyContent?.subject,
        survey_id: surveyContent?.survey_id,
        survey_host: surveyContent?.survey_host,
      });
      hasTrackedRef.current = true;
    }
  }, [surveyContent]);
  // UTM Sign-up URL
  const signUpUrl = `https://professionals${suffix}.newtonx.com/?utm_source=${source}&utm_medium=survey-experience&utm_campaign=survey-${SEID}&utm_content=quota-page&utm_term=survey_id_${survey_id}`;
  const trackSignUp = () => {
    surveyPortalMixpanel.track('Sign Up Button Clicked', {
      SSEID: surveyContent?.subject,
      survey_id: surveyContent?.survey_id,
      survey_host: surveyContent?.survey_host,
      source: 'Survey',
      button_location: 'Quota page',
    });
  };
  const accordionItems = [
    {
      title: 'What does it mean to reach a quota?',
      content: (
        <Typography variant="body2">
          When a survey reaches its quota, it means that enough people with specific characteristics
          (like age, location, or skills) have already completed it. Once these limits are reached
          for your particular group, we screen out new respondents with similar characteristics to
          ensure a balanced sample.
        </Typography>
      ),
    },
    {
      title: 'Am I going to get paid?',
      content: (
        <Typography variant="body2">
          Because you did not advance beyond the screener, you are not eligible for payment.
        </Typography>
      ),
    },
    {
      title: 'How can I qualify in the future?',
      content: (
        <>
          <Typography variant="body2" marginBottom="16px">
            To help us target you with better opportunities, make sure your profile is updated:
          </Typography>
          <Button
            fullWidth
            variant="outlined"
            color="info"
            href={signUpUrl}
            component="a"
            target="_blank"
            rel="noopener noreferrer"
          >
            UPDATE PROFILE
          </Button>
        </>
      ),
    },
  ];
  return (
    <Box maxWidth="480px">
      <Typography variant={'h2'} marginBottom="16px" fontWeight={700}>
        We’ve reached our quota
      </Typography>
      <Typography variant={'body1'} color={'text.secondary'} marginBottom="16px">
        It looks like we already met our quota for professionals matching your experience.
      </Typography>
      <Typography variant={'body1'} color={'text.secondary'} marginBottom="32px">
        We’ll continue to reach out with opportunities. We hope to work with you soon!
      </Typography>
      <Typography variant={'h3'} marginBottom="16px" fontWeight={700}>
        Be the first to know!
      </Typography>
      <Typography variant={'body1'} color={'text.secondary'} marginBottom="16px">
        Hear about your next opportunity faster by joining the NewtonX Professionals Community.
      </Typography>
      <Button
        fullWidth
        variant="outlined"
        color="primary"
        href={signUpUrl}
        sx={{ marginBottom: '32px' }}
        component="a"
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackSignUp}
      >
        SIGN UP
      </Button>
      <Box display="flex" marginBottom="8px">
        <Box
          component={'img'}
          sx={{
            width: '24px',
            height: '24px',
            marginRight: '8px',
          }}
          alt="user_questions"
          src={srcIcon}
        ></Box>
        <Typography variant={'h4'} fontWeight={700}>
          Frequently Asked Questions
        </Typography>
      </Box>
      <Box>
        <Accordion items={accordionItems}></Accordion>
      </Box>
    </Box>
  );
};

export default Quota;
